import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewStudentComp from "./Component/ViewStudentComp"


const ViewStudent =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewStudentComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewStudent